import { useContext } from "react";
import { getConfigValue } from "@jutro/config";
import { AuthContext } from "./AuthContext";
export var useGenericAuth = function () {
  var isGenericClient = getConfigValue("JUTRO_AUTH_GENERIC_CLIENT", !1),
    auth = useContext(AuthContext);
  if (isGenericClient && !auth) throw new Error("useAuth must be used within AuthProvider");
  return auth;
};